export function createProfilePicture({ src, id, initials, alt = "" }) {
  if (src) {
    const img = document.createElement("img");
    img.src = src;
    img.alt = alt;
    img.classList.add("profile-picture", "profile-picture--sm");
    return img;
  }

  const span = document.createElement("span");
  span.classList.add("profile-picture", "profile-picture--sm");

  if (id) {
    span.classList.add(`has-bg-category-${(id % 9) + 1}`);
    span.textContent = initials;
  }

  return span;
}
